import { tns } from "tiny-slider/src/tiny-slider"
export default HeroSlider

function HeroSlider() {
  const buttons = document.querySelectorAll('.js-hero-slider-nav')
  if (buttons.length < 1) return
  
  const slider = tns({
    container: '.js-hero-slider',
    controls: false,
    nav: false
  })
  if (!buttons) {
    return
  }

  ;[...buttons].forEach((button) => {
    button.addEventListener('click', function () {
      const { direction } = this.dataset
      slider.goTo(direction)
    })
  })
}


// WEBPACK FOOTER //
// ./src/js/modules/HeroSlider.js